import React, { useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Col, Row, FormLabel, Button, FormGroup, Image as BootstrapImage,
} from 'react-bootstrap';

import { getBase64 } from '../tools/getBase64';

export default function Gallery({
    isLocked, images, onImagesChange, onImageClick,
}) {
    const inputRef = useRef(null);

    async function handlePicChange(e) {
        const { files } = e.currentTarget;

        const newImages = [];

        for (let i = 0; i < Object.keys(files).length; i++) {
            const file = files[i];
            const result = await getBase64(file);

            newImages.push({
                type: 'picture',
                file: result,
                label: file.name,
            });
        }

        onImagesChange([
            ...images,
            ...newImages,
        ]);
    }

    function handleImageRemove(e) {
        const newImages = images.filter((image) => +image.id !== +e.currentTarget.id);
        onImagesChange(newImages);
    }

    return (
        <div>
            <FormLabel><b>Галерея</b></FormLabel>
            {isLocked ? (
                <Row>
                    <Col md={12}>
                        <strong>Чтобы разблокировать галерею, сохраните материал.</strong>
                    </Col>
                </Row>
            ) : (
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={6}>
                                Картинки
                                {' '}
                                <span
                                    style={{
                                        color: '#999', fontSize: '13px', marginBottom: '8px', display: 'inline-block',
                                    }}
                                >
                                    (.jpg, .png, .webp)
                                </span>
                            </Col>
                            <Col md={12}>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup controlId="save">
                                            <input
                                                accept="image/jpeg,image/png,image/webp"
                                                multiple="multiple"
                                                id="gallery_pic"
                                                type="file"
                                                onChange={handlePicChange}
                                                ref={inputRef}
                                                style={{ display: 'none' }}
                                            />
                                            <Button
                                                variant="outline-dark"
                                                block
                                                onClick={() => inputRef.current.click()}
                                            >
                                                <FontAwesomeIcon
                                                    icon="hdd"
                                                />
                                                {' '}
                                                С диска
                                            </Button>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            {images?.filter(({ type }) => type === 'picture').map((image) => (
                                <Col
                                    md={4}
                                    key={image.id ? `pic_${image.id}` : Math.random()}
                                    style={{
                                        opacity: image.id ? 1 : 0.4, pointerEvents: image.id ? 'auto' : 'none',
                                    }}
                                >
                                    <Row>
                                        <Col md={{ offset: 6, span: 1 }}>
                                            <Button
                                                variant="link"
                                                id={image.id}
                                                onClick={handleImageRemove}
                                            >
                                                <FontAwesomeIcon
                                                    icon="trash"
                                                />
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <Button
                                                id={image.id}
                                                data-label={image.label}
                                                variant="link"
                                                onClick={onImageClick}
                                            >
                                                <BootstrapImage
                                                    id={image.id}
                                                    src={image.file}
                                                    fluid
                                                    rounded
                                                />
                                            </Button>

                                            <a href={image.file} target="_blank" rel="noopener noreferrer">
                                                <p style={{ wordBreak: 'break-all' }} id={image.id}>
                                                    {image.label}
                                                </p>
                                            </a>
                                        </Col>
                                    </Row>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>
            )}
        </div>
    );
}
